const STYLES = {
  Hot: "bg-red-100 text-red-800 border-red-300",
  Warm: "bg-amber-100 text-amber-800 border-amber-300",
  Cold: "bg-sky-100 text-sky-800 border-sky-300",
};

export const LabelBadge = ({ label }) => (
  <span className={`inline-flex px-2.5 py-0.5 rounded-full border text-xs font-semibold ${STYLES[label] || STYLES.Warm}`} data-testid={`lead-label-${label?.toLowerCase()}`}>{label}</span>
);

const fmtDate = (s) => new Date(s).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });

export default function LeadTable({ leads, onSelect }) {
  if (!leads) return <p className="text-[#57645A]">Loading…</p>;
  if (leads.length === 0) return <div className="bg-white border border-parchment-300 rounded-2xl p-10 text-center text-[#57645A]" data-testid="leads-empty">No leads yet. They appear here when a visitor ends a chat with Prana.</div>;

  return (
    <div className="bg-white border border-parchment-300 rounded-2xl overflow-hidden" data-testid="leads-table">
      <div className="hidden md:grid grid-cols-[1.2fr_1fr_1.4fr_0.6fr_0.9fr] gap-4 px-5 py-3 text-xs uppercase tracking-widest text-[#8A978E] border-b border-parchment-300 bg-parchment">
        <span>Name</span><span>Phone</span><span>Interested in</span><span>Label</span><span>Date</span>
      </div>
      {leads.map((l) => (
        <button key={l.id} onClick={() => onSelect(l)} className="w-full text-left grid grid-cols-[1fr_auto] md:grid-cols-[1.2fr_1fr_1.4fr_0.6fr_0.9fr] gap-x-4 gap-y-1 px-5 py-4 border-b border-parchment-200 last:border-0 hover:bg-parchment transition-colors items-center" data-testid={`lead-row-${l.id}`}>
          <span className="font-semibold text-forest-800">{l.name || "Unknown"}</span>
          <span className="md:hidden justify-self-end"><LabelBadge label={l.label} /></span>
          <span className="text-sm text-[#57645A]">{l.phone || "—"}</span>
          <span className="text-sm text-[#57645A] truncate col-span-2 md:col-span-1">{l.interested_course || "—"}</span>
          <span className="hidden md:block"><LabelBadge label={l.label} /></span>
          <span className="text-xs text-[#8A978E] col-span-2 md:col-span-1">{fmtDate(l.created_at)}</span>
        </button>
      ))}
    </div>
  );
}
